import classNames from "classnames";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { useDispatch } from "@/redux/hooks";
import { CLOSE_NAVIGATION } from "@/redux/reducers/header";

const NavigationItem: React.FC<{
  as?: string;
  dataTestId?: string;
  className?: string;
  highlight?: Array<string | RegExp>;
  href: string;
  onClick?: () => void;
  children?: React.ReactNode;
}> = ({ as, className, children, dataTestId, highlight, href, onClick }) => {
  const dispatch = useDispatch();
  const pathname = String(usePathname());
  const matchesHighlights = (highlight || []).some((pattern) =>
    typeof pattern === "string"
      ? pathname.startsWith(pattern)
      : pathname.match(pattern),
  );
  const matchesHref = pathname === href;

  const AsElement = (as || Link) as React.ElementType;

  return (
    <li>
      <AsElement
        data-testid={dataTestId || "navigation-item"}
        className={classNames(className, {
          "font-bold": matchesHref || matchesHighlights,
        })}
        href={href}
        onClick={() => {
          onClick?.();
          dispatch({ type: CLOSE_NAVIGATION });
        }}
      >
        {children}
      </AsElement>
    </li>
  );
};

export default NavigationItem;
